import React from 'react';
import {Box, Typography} from '@mui/material';
import {CategoryPoint} from '@/types';

type PointsListProps = {
    points: CategoryPoint[];
};

const PointsList: React.FC<PointsListProps> = ({points}) => {

    return (
        <Box sx={{pt: 3}}>
            {points.map((p: CategoryPoint, i) => (
                <Box
                    key={i}
                    sx={{
                        display: 'grid',
                        alignItems: 'flex-start',
                        gridTemplateColumns: 'max-content 1fr',
                        ml: 2,
                        mb: 2,
                        gap: 1,
                    }}
                    className="rotate-in"
                >
                    {!!p.icon && <p.icon/>}
                    <Typography variant="h6" component="h6" align="left" m={0} sx={{fontSize: '16px'}}>
                        {p.title}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default PointsList;
